export enum ProjectOAuth2SalesforcePrompt {
    Login = 'login',
    Consent = 'consent',
}
